export default __webpack_public_path__ + "assets/elsalvador-flag.png";